import React, { useEffect, useState } from 'react';
import { Badge, Menu, message } from "antd";
import { Link } from "react-router-dom";
import { BookOutlined, DatabaseOutlined, EnvironmentOutlined, FileDoneOutlined, FileProtectOutlined, HomeOutlined, InfoCircleOutlined, MonitorOutlined, PieChartOutlined, QuestionCircleOutlined, StopOutlined, UnorderedListOutlined, UsergroupAddOutlined, UserOutlined, UserSwitchOutlined } from "@ant-design/icons";
import axios from '../../util/Api';
import SubMenu from 'antd/lib/menu/SubMenu';
import { useSelector } from 'react-redux';

const Admin = (props) => {
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(null);
  const { authUser } = useSelector(({ auth }) => auth);

  useEffect(() => {
    fetchPassport();
  }, []);

  const fetchPassport = () => {
    setLoading(true);
    const url = `/passport/request-count`;
    axios.get(url, { params: {status: 10} }).then(resp => {
      setCount(resp.data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
    });
  }

  return (
    <Menu {...props}>
      <Menu.Item key="dashboard">
        <Link to="/dashboard">
          <HomeOutlined />
          <span>Dashboard</span>
        </Link>
      </Menu.Item>
      <Menu.ItemGroup key="operational" className="gx-menu-group" title="Operasional">
        <Menu.Item key="request">
          <Badge count={loading ? null : count} offset={[10,0]}>
            <Link to="/request?sort=updated_at">
              <FileDoneOutlined />
              <span>Request</span>
            </Link>
          </Badge>
        </Menu.Item>
        <Menu.Item key="presence">
          <Badge>
            <Link to="/presence">
              <UserSwitchOutlined />
              <span>Absensi</span>
            </Link>
          </Badge>
        </Menu.Item>
        <Menu.Item key="passport">
          <Link to="/passport">
            <UserOutlined />
            <span>Personel</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="training">
          <Link to="/training">
            <BookOutlined />
            <span>Data Training</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="violation">
          <Link to="/violation">
            <StopOutlined />
            <span>Pelanggaran</span>
          </Link>
        </Menu.Item>
        {authUser.is_superadmin ? <Menu.Item key="project">
          <Link to="/project">
            <EnvironmentOutlined />
            <span>Project</span>
          </Link>
        </Menu.Item> : null}
        <Menu.Item key="vendor">
          <Link to="/vendor">
            <FileProtectOutlined />
            <span>Perusahaan</span>
          </Link>
        </Menu.Item>
      </Menu.ItemGroup>

      {authUser.is_superadmin ? <Menu.ItemGroup key="master-data" className="gx-menu-group" title="Manajemen Data">
        <Menu.Item key="users">
          <Link to="/users">
            <UsergroupAddOutlined />
            <span>User</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="faq/manage">
          <Link to="/faq/manage">
            <QuestionCircleOutlined />
            <span>Kelola FAQ</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="broadcast">
          <Link to="/broadcast">
            <InfoCircleOutlined />
            <span>Broadcast</span>
          </Link>
        </Menu.Item>

        <SubMenu key="general" title={
          <span>
            <i className="icon icon-all-contacts" />
            <span>Master</span>
          </span>}>
          <Menu.Item key="sickness">
            <Link to="/sickness">
              <DatabaseOutlined />
              <span>Riwayat Kesehatan</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="skills">
            <Link to="/skills">
              <DatabaseOutlined />
              <span>Kompetensi</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      </Menu.ItemGroup> : null }

      <Menu.ItemGroup key="summaries" className="gx-menu-group" title="Summaries">
        <Menu.Item key="monitoring">
          <Link to="/monitoring">
            <MonitorOutlined />
            <span>Monitoring</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="vendor/classification">
          <Link to="/vendor/classification">
            <PieChartOutlined />
            <span>Klasifikasi Perusahaan</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="project/registered">
          <Link to="/project">
            <PieChartOutlined />
            <span>Total Teregister</span>
          </Link>
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );
}

export default Admin;